import {ChangeDetectorRef, Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {UnassociatedService} from '../../providers/unassociated.service';

/**
 * Generated class for the PopoverCyclecountProgressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover-unassociated-progress',
  templateUrl: 'popover-unassociated-progress.html',
})
export class PopoverUnassociatedProgressPage {

  title = '';
  progress = '0';
  shouldUpdateView = true;
  // colorBar = COLOR_LOCATE_ITEM_MODULE;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private unassociatedService: UnassociatedService,
              public translate: TranslateService,
              private cdr: ChangeDetectorRef) {
    this.title = navParams.get('title');
    this.initRecursiveGetProgress();
  }

  ionViewWillLeave(){
    this.shouldUpdateView = false;
  }

  // TODO: CHANGE TO EVENTS
  initRecursiveGetProgress() {
    setTimeout(() => {
      if(this.shouldUpdateView){
        this.progress = String(Math.trunc(this.unassociatedService.getProgress() < 100 ? this.unassociatedService.getProgress() : 100));
        this.cdr.detectChanges();
        this.initRecursiveGetProgress();
      }
    }, 300);
  }
}



// WEBPACK FOOTER //
// ./src/pages/popover-unassociated-progress/popover-unassociated-progress.ts